import React from 'react';
import { Box, Container, Typography, Grid, useTheme as useMuiTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

const SectionTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(6),
  position: 'relative',
  display: 'inline-block',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-10px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '80px',
    height: '4px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '2px',
  },
}));

const About = () => {
  const theme = useMuiTheme();

  return (
    <Box 
      id="about" 
      sx={{ 
        py: { xs: 8, md: 12 },
        backgroundColor: 'background.paper',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <SectionTitle
              variant="h2"
              component="h2"
              sx={{ 
                fontWeight: 700,
                color: 'primary.main'
              }}
            >
              About Me
            </SectionTitle>
          </motion.div>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Typography 
                variant="h5" 
                sx={{ 
                  mb: 3,
                  color: 'text.primary',
                  fontWeight: 500,
                  textAlign: 'center'
                }}
              >
                Computer Engineering Student & Software Developer
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: 'text.secondary',
                  lineHeight: 1.8,
                  fontSize: '1.1rem',
                  textAlign: 'center',
                  maxWidth: '900px',
                  mx: 'auto'
                }}
              >
                I'm a senior Computer Engineering student at the National University of Singapore 
                with a passion for building impactful software solutions. My experience spans across 
                IoT systems, mobile development, embedded systems, and web technologies. I thrive in 
                collaborative environments and love tackling complex technical challenges that make 
                a real difference.
              </Typography>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
